import { lazy } from "react";
import { Route } from "react-router-dom";

import type { useCheckoutSessionConfig } from "@dues/hooks/useCheckoutSessionConfig";
import { CheckoutRoutes } from "@dues/pages/Checkout";
import { routes as renegKitRoutes } from "@libs/renegkit";
import { pageNames } from "@shared/routes/pageNames";

const MyDebts = lazy(() => import("@dues/pages/MyDebts"));
const Debts = lazy(() => import("@dues/pages/Debts"));
const MyAgreements = lazy(() => import("@dues/pages/RKMyAgreements"));
const NegativeDebts = lazy(() => import("@dues/pages/NegativeDebts"));

type DuesPrivateRouterProps = {
	checkoutSessionConfig: ReturnType<typeof useCheckoutSessionConfig>;
};

export function DuesPrivateRouter({
	checkoutSessionConfig,
}: DuesPrivateRouterProps) {
	return (
		<>
			<Route
				path={pageNames.myDebts.path}
				element={<MyDebts />} /* /minhas-dividas */
			/>
			<Route path={pageNames.debts.path} element={<Debts />} /* /dividas */ />
			<Route
				path={pageNames.negativeDebts.path}
				element={<NegativeDebts />} /* /debitos-negativados */
			/>
			<Route
				path={renegKitRoutes.myAgreements.path}
				element={<MyAgreements />}
			/>
			{CheckoutRoutes({ checkoutSessionConfig })}
		</>
	);
}
